var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (showSearch) { ;
__p += '\n<div class="CDB-Widget-contentFlex">\n  <button class="u-rSpace--m CDB-Text is-semibold u-upperCase CDB-Size-small js-searchToggle">\n    <div class="CDB-Shape u-iBlock">\n      <span class="CDB-Shape-magnify is-small is-blue"></span>\n    </div>\n    <span class="u-iBlock u-actionTextColor">\n      search in ' +
__e( categoriesCount ) +
' categor' +
__e( categoriesCount === 1 ? 'y' : 'ies' ) +
'\n    </span>\n  </button>\n</div>\n';
 } ;
__p += '\n';
 if (showPaginator) { ;
__p += '\n  <div class="CDB-Widget-navDots js-dots">\n    ';
 for (var i = 0, l = pages; i < l; i++) { ;
__p += '<button class="CDB-Shape-dot CDB-Widget-dot--navigation js-page ';
 if (currentPage === i) { ;
__p += 'is-selected';
 } ;
__p += '" data-page="' +
__e( i ) +
'"></button>';
 } ;
__p += '\n  </div>\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/widgets/category/paginator/paginator-template.tpl
// module id = 861
// module chunks = 2 3